import {BaseDTO} from "../../../../uinspect/src/app/global/interfaces/index";
import {ValuationNodeDTO} from "./valuation-node-dto.interface";
import {IValuationNode} from "./valuation-node.interface";

export interface ValuationPillarDTO extends BaseDTO, IValuationNode {
  valuationProfileId: string;
  lookupValue: number;
  valuationNodes: ValuationNodeDTO[];
}
